import { Fragment, useCallback } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useAtomValue, useUpdateAtom } from 'jotai/utils';
import { productImagesAtom, productVariantsAtom } from 'global/store';
import useColors from 'hooks/products/useColors';
import VariantSelect from '@/UI/Form/Selects/VariantSelect';
import { FlexBox } from '@/UI/Primitives/FlexBox';

export default function CustomOptions({ product }) {
  const { control, reset } = useForm();

  const selectedVariants = useAtomValue(productVariantsAtom);
  const setImages = useUpdateAtom(productImagesAtom);

  const { colors } = useColors(product);

  const customOptions = product?.configurable_options?.filter(
    option => option.attribute_code !== 'v__rv'
  );

  const getConfigurableOptionValues = attribute => {
    const options = product?.configurable_options?.filter(
      option => option.attribute_code === attribute
    )[0]?.values;

    return options
      ?.map(option => {
        return { ...option, value: option.label, attribute };
      })
      ?.sort((a, b) => a.label - b.label);
  };

  const setGallery = useCallback(() => {
    for (const variant of selectedVariants) {
      const color = colors?.find(({ attributes }) =>
        attributes.find(({ uid }) => uid === variant.uid)
      );
      const images = color?.product?.media_gallery;

      setImages(images?.length > 0 ? images : product?.media_gallery);
    }
  }, [selectedVariants, colors]);

  return (
    <FlexBox
      dir="column"
      pt={{ _: 8, desktop: 40 }}
      pb={{
        _: customOptions?.length > 0 ? 8 : 0,
        desktop: 16
      }}
    >
      {customOptions?.length > 0 &&
        customOptions.map(({ attribute_code, label }) => {
          const optionValues = getConfigurableOptionValues(attribute_code);
          return (
            <Fragment key={label}>
              <h4>{label}:</h4>
              <Controller
                name={label}
                control={control}
                render={({ field }) => (
                  <VariantSelect
                    {...field}
                    options={optionValues}
                    setGallery={setGallery}
                    reset={reset}
                  />
                )}
              />
            </Fragment>
          );
        })}
    </FlexBox>
  );
}
